module.exports = __webpack_public_path__ + "static/img/QQ.3728fbaa.svg";